import { Entity } from '@backstage/catalog-model';

/** @public */
export const AWS_ACCOUNT_ANNOTATION = 'amazonaws.com/account-id';

/** @public */
export const AZURE_SUBSCRIPTION_ANNOTATION = 'azure.com/subscription-id';

/** @public */
export const AZURE_TENANT_ANNOTATION = 'azure.com/tenant-id';

/**
 * Determines if the given entity represents an AWS account.
 * @param entity - The entity to check.
 * returns `true` if the entity is an AWS account, otherwise `false`.
 */
export const isAwsAccount = (entity: Entity) =>
  Boolean(entity.metadata.annotations?.[AWS_ACCOUNT_ANNOTATION]);

/**
 * Determines if the given entity represents an Azure subscription.
 * @param entity - The entity to check.
 * returns `true` if the entity is an Azure subscription, otherwise `false`.
 */
export const isAzureSubscription = (entity: Entity) =>
  Boolean(entity.metadata.annotations?.[AZURE_SUBSCRIPTION_ANNOTATION]);

/**
 * Determines if the given entity is not a dev account.
 * @param entity - The entity to check.
 * returns `true` if the entity is not a dev account, otherwise `false`.
 */
export const isNotDevAwsAccount = (entity: Entity) =>
  Boolean(
    entity.metadata.annotations?.[AWS_ACCOUNT_ANNOTATION] &&
      entity.metadata.labels?.['pfg-env-type'] !== 'dev',
  );
